<div class="d-flex justify-content-between w-100">
	<h3>{{ data.editable ? 'Dodaj notatke' : 'Podgląd notatki' }}</h3>
	<i (click)="dialogRef.close()" role="button" class="fas fa-times fs-2"></i>
</div>
<div class="form">
	<div class="d-flex">
		<div class="me-4">
			<div class="mb-3">
				<mat-form-field class="w-note" appearance="outline">
					<mat-label class="form-label">Treść zmodyfikowanej notatki</mat-label>
					<textarea [disabled]="!data.editable" [(ngModel)]="noteText" rows="10" matInput></textarea>
				</mat-form-field>
				<div class="d-flex justify-content-end mt-2">
					<button [hidden]="!data.editable" mat-raised-button color="accent" (click)="Input.click()">
						<i class="fa-solid fa-file-circle-plus"></i> Dodaj zdjęcia
					</button>
					<input #Input class="d-none" type="file" multiple (change)="uploadFile($event)" />
				</div>
				<div *ngFor="let image of uploadedMultimedia; let i = index">
					<div class="d-flex justify-content-center my-2">
						<div
							class="note-thumbnail position-relative overflow-hidden cursor-pointer flex-shrink-0"
							role="button"
							tabindex="0"
							(click)="openImagePreview(image.url)"
						>
							<img
								class="note-thumbnail-img w-100 h-100 object-fit-cover"
								[src]="image.url"
								alt="Zdjęcie notatki"
							/>
							<div
								class="note-thumbnail-overlay position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50"
							>
								<i class="fas fa-eye text-white fs-4" aria-hidden="true"></i>
							</div>
						</div>
						<div class="align-self-center ms-3">
							<button [disabled]="!data.editable" (click)="deleteImage(i)" mat-raised-button color="warn">
								Usuń zdjęcie
								<i class="fas fa-times"></i>
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div>
			Rodzaj notatek
			<section>
				<ul *ngFor="let item of data.kinds" class="list-inline">
					<li>
						<mat-checkbox
							[disabled]="!data.editable"
							color="primary"
							[(ngModel)]="item.isChecked"
							[checked]="item.isChecked"
						>
							{{ item.name }}
						</mat-checkbox>
					</li>
				</ul>
			</section>
		</div>
	</div>
	<p class="text-secondary text-decoration-underline" *ngIf="!data.editable">
		Notatkę można edytować tylko przez 15 min od jej utworzenia!
	</p>
	<div class="text-end">
		<button [hidden]="!data.editable" mat-raised-button color="primary" (click)="saveNote()">Zapisz</button>
	</div>
</div>

@if (previewImageUrl) {
	<div
		class="position-fixed top-0 start-0 w-100 vh-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-75 p-4"
		style="z-index: 1100"
		(click)="closeImagePreview()"
	>
		<button
			mat-fab
			type="button"
			class="position-absolute top-0 end-0 m-3"
			aria-label="Zamknij podgląd"
			(click)="closeImagePreview(); $event.stopPropagation()"
		>
			<i class="fas fa-times"></i>
		</button>
		<img
			class="mw-100 mh-100 object-fit-contain"
			[src]="previewImageUrl"
			alt="Podgląd zdjęcia"
			(click)="$event.stopPropagation()"
		/>
	</div>
}
